import { Range, Editor, Transforms } from 'slate';
import { findListItems } from '../queries/findListItems.mjs';

function removeList(editor, options) {
  const {
    defaultBlockType
  } = options;
  let {
    at = editor.selection
  } = options;
  if (Range.isRange(at)) {
    at = Editor.unhangRange(editor, at);
  }
  if (!at) {
    return;
  }
  const listItems = findListItems(editor, {
    at
  });
  Editor.withoutNormalizing(editor, () => {
    if (listItems.length > 0) {
      const refs = listItems.map(([, path]) => Editor.pathRef(editor, path));
      refs.forEach(ref => {
        if (ref.current) {
          const newAttributes = {
            type: defaultBlockType
          };
          Transforms.setNodes(editor, newAttributes, {
            at: ref.current
          });
          Transforms.liftNodes(editor, {
            at: ref.current,
            mode: 'all'
          });
        }
        ref.unref();
      });
    }
  });
  Editor.normalize(editor, {
    force: true
  });
}

export { removeList };
